if (!customElements.get('announcement-ticker')) {
  customElements.define('announcement-ticker', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-announcement-track]');
      this.group = this.querySelector('[data-announcement-group]');
      this.sequence = this.querySelector('[data-announcement-sequence]');
      if (!this.track || !this.group || !this.sequence) return;

      this.lastSize = '';
      this.scheduleUpdate = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.observer = new ResizeObserver(this.scheduleUpdate);
      this.observer.observe(this);
      this.observer.observe(this.sequence);
      this.scheduleUpdate();
      document.fonts.ready.then(() => {
        if (this.isConnected) this.scheduleUpdate();
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    createCopy(element) {
      const copy = element.cloneNode(true);
      copy.setAttribute('data-announcement-copy', '');
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      for (const node of [copy, ...copy.querySelectorAll('[id], [block-id], [data-shopify-editor-block]')]) {
        node.removeAttribute('id');
        node.removeAttribute('block-id');
        node.removeAttribute('data-shopify-editor-block');
      }
      return copy;
    }

    update() {
      if (!this.isConnected) return;
      const viewportWidth = this.getBoundingClientRect().width;
      const sequenceWidth = this.sequence.getBoundingClientRect().width;
      if (!viewportWidth || !sequenceWidth) return;
      const size = `${viewportWidth}:${sequenceWidth}`;
      if (size === this.lastSize) return;
      this.lastSize = size;

      this.removeAttribute('data-ready');
      this.track.replaceChildren(this.group);
      this.group.replaceChildren(this.sequence);
      const repetitions = Math.max(1, Math.ceil(viewportWidth / sequenceWidth));
      for (let index = 1; index < repetitions; index += 1) {
        this.group.append(this.createCopy(this.sequence));
      }
      const distance = this.group.getBoundingClientRect().width;
      const speed = Math.max(10, Number(this.dataset.speed) || 40);
      this.style.setProperty('--announcement-distance', `${distance}px`);
      this.style.setProperty('--announcement-duration', `${distance / speed}s`);
      this.track.append(this.createCopy(this.group));
      this.setAttribute('data-ready', '');
    }
  });
}
